import get from 'lodash/get';
import set from 'lodash/set';

const addError = (errors, field, error) => {
    if (!error) {
        return;
    }

    const existingError = get(errors, field);

    if (existingError) {
        set(errors, field, `${existingError}\n${error}`);
    } else {
        set(errors, field, error);
    }
};

export { addError };
